export default __webpack_public_path__ + "static/media/watches14.f98c3894.jfif";